import { safeAccess } from '../../../utils';

export const getBenefitData = (state, id) => safeAccess(state, `planTool.cache[${id}]`, {});
